import styles from './Navbar.module.css';

import { getImageURL } from '../../utils';

import { Link } from 'react-router-dom';
import React from "react";

function Navbar() {
    const [menuOpen, setMenuOpen] = React.useState(false);

    return (
        <nav className={styles.navbar}>
            <Link className={styles.title} to='/'>Home</Link>
            <div className={styles.menu}>
                <img
                    className={styles.menuBtn}
                    src={menuOpen ? getImageURL('nav/closeIcon.png') : getImageURL('nav/menuIcon.png')}
                    alt='menu-button'
                    onClick={() => setMenuOpen(!menuOpen)}
                />
                <ul
                    className={`${styles.menuItems} ${menuOpen && styles.menuOpen}`}
                    onClick={() => setMenuOpen(false)}
                >
                    <li><Link to='/projects'>Projects</Link></li>
                    <li><a>Temp</a></li>
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;